import InitialRegistration from './InitialRegistration';

export default InitialRegistration;
